// import asset image 
import btcBulb from '../../assets/images/onboarding/btc-bulb.svg'

 const onBoardingData = {
    slides:[
        {
            id: 1,
            title: 'Copy & Trade Together',
            body: 'Lorem ipsum dolor sit amet, consectetur adipiscing nim',
            image: btcBulb,
        },
        {
            id: 2,
            title: 'Copy & Trade Together 2',
            body: 'Lorem ipsum dolor sit amet, consectetur adipiscing nim',
            image: btcBulb,
        },
        {
            id: 3,
            title: 'Copy & Trade Together 3',
            body: 'Lorem ipsum dolor sit amet, consectetur adipiscing nim',
            image: btcBulb,
        }
    ]
}


export default onBoardingData;